export const LAMBDATEST_TEST_DATA_LOADING = "LAMBDATEST_TEST_DATA_LOADING";
export const LAMBDATEST_TEST_DATA_LOADING_MORE =
  "LAMBDATEST_TEST_DATA_LOADING_MORE";
export const LAMBDATEST_TEST_DATA_SUCCESS = "LAMBDATEST_TEST_DATA_SUCCESS";
export const LAMBDATEST_TEST_DATA_FAILED = "LAMBDATEST_TEST_DATA_FAILED";
export const LAMBDATEST_TEST_DATA_CLEAR = "LAMBDATEST_TEST_DATA_CLEAR";

export const LAMBDATEST_INFINITE_TEST_DATA_LOADING =
  "LAMBDATEST_INFINITE_TEST_DATA_LOADING";
export const LAMBDATEST_INFINITE_TEST_DATA_SUCCESS =
  "LAMBDATEST_INFINITE_TEST_DATA_SUCCESS";
export const LAMBDATEST_INFINITE_TEST_DATA_FAILED =
  "LAMBDATEST_INFINITE_TEST_DATA_FAILED";
export const LAMBDATEST_INFINITE_TEST_DATA_CLEAR =
  "LAMBDATEST_INFINITE_TEST_DATA_CLEAR";
export const LAMBDATEST_INFINITE_TEST_DATA_SILENT_LOADING =
  "LAMBDATEST_INFINITE_TEST_DATA_SILENT_LOADING";

export const LAMBDATEST_TEST_DATA_FETCH_MORE_LOADING =
  "LAMBDATEST_TEST_DATA_FETCH_MORE_LOADING";
export const LAMBDATEST_TEST_DATA_FETCH_MORE_SUCCESS =
  "LAMBDATEST_TEST_DATA_FETCH_MORE_SUCCESS";
export const LAMBDATEST_TEST_DATA_FETCH_MORE_FAILED =
  "LAMBDATEST_TEST_DATA_FETCH_MORE_FAILED";
export const LAMBDATEST_WITHOUT_BUILD_LOADING =
  "LAMBDATEST_WITHOUT_BUILD_LOADING";
export const LAMBDATEST_WITHOUT_BUILD_SUCCESS =
  "LAMBDATEST_WITHOUT_BUILD_SUCCESS";
export const LAMBDATEST_WITHOUT_BUILD_FAILURE =
  "LAMBDATEST_WITHOUT_BUILD_FAILURE";
export const LAMBDATEST_TEST_DATA_UPDATE_SSE_EVENT =
  "LAMBDATEST_TEST_DATA_UPDATE_SSE_EVENT";
export const LAMBDATEST_UPDATE_TESTNAME_LOADING =
  "LAMBDATEST_UPDATE_TESTNAME_LOADING";
export const LAMBDATEST_UPDATE_TESTNAME_SUCCESS =
  "LAMBDATEST_UPDATE_TESTNAME_SUCCESS";
export const LAMBDATEST_UPDATE_TESTNAME_FAILED =
  "LAMBDATEST_UPDATE_TESTNAME_FAILED";
export const LAMBDATEST_UPDATE_TESTNAME_CLEAR =
  "LAMBDATEST_UPDATE_TESTNAME_CLEAR";
export const LAMBDATEST_TEST_SEARCH_LOADING = "LAMBDATEST_TEST_SEARCH_LOADING";
export const LAMBDATEST_TEST_SEARCH_SUCCESS = "LAMBDATEST_TEST_SEARCH_SUCCESS";
export const LAMBDATEST_TEST_SEARCH_FAILED = "LAMBDATEST_TEST_SEARCH_FAILED";
export const LAMBDATEST_TEST_SEARCH_CLEAR = "LAMBDATEST_TEST_SEARCH_CLEAR";
export const LAMBDATEST_TEST_DATA_ADD = "LAMBDATEST_TEST_DATA_ADD";
export const LAMBDATEST_TEST_DATA_UPDATE = "LAMBDATEST_TEST_DATA_UPDATE";
export const FETCH_FLAXY_TESTS_IN_BUILD_LOADING =
  "FETCH_FLAXY_TESTS_IN_BUILD_LOADING";
export const FETCH_FLAXY_TESTS_IN_BUILD_SUCCESS =
  "FETCH_FLAXY_TESTS_IN_BUILD_SUCCESS";
export const FETCH_FLAXY_TESTS_IN_BUILD_FAILED =
  "FETCH_FLAXY_TESTS_IN_BUILD_FAILED";
export const LAMBDATEST_TEST_DATA_REMOVE = "LAMBDATEST_TEST_DATA_REMOVE";
export const SET_SHOULD_FILTER_UNIQUE_TESTS = "SET_SHOULD_FILTER_UNIQUE_TESTS";
export const LAMBDATEST_DELETE_TEST_LOCAL = "LAMBDATEST_DELETE_TEST_LOCAL";
export const LAMBDATEST_SSE_TEST_LIST_DATA_UPDATE =
  "LAMBDATEST_SSE_TEST_LIST_DATA_UPDATE";
export const LAMBDATEST_UPDATE_TESTDATA = "LAMBDATEST_UPDATE_TESTDATA";

export const UPDATE_TEST_MUTE_STATUS_SIDEBAR_LIST = "UPDATE_TEST_MUTE_STATUS_SIDEBAR_LIST";